import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Outlet, useLocation, useNavigate } from "react-router-dom";
import Home from "./Home";
import BackgroundVideo from "./BackgroundVideo";
import { referenceCategories } from "../referenceCategories";
import { siteDetails } from "../siteDetails";
import { Link } from "react-scroll";


export default function App({ Router = BrowserRouter }) {
  return (<>
    <Router>
      <Routes>
        <Route path="/" element={<Layout />} >
          <Route index element={<Home />} />

          <Route path="*" element={<NoMatch />} />
        </Route>
      </Routes>
    </Router>
  </>);
}

const Layout = () => {

  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {

  }, [location])

  const setRefTabParam = (key) => {
    const params = new URLSearchParams(location.search);
    params.set("ref", key);                          // nycklar: kakelugn, insatser, kaminer, vedspis, skorsten, skorstenrenovering
    navigate({ search: params.toString() }, { replace: true });
  };

  return (<>
    <section role="navigation">

      <nav>
        <ul>
          <li>
            <Link activeClass="flame" smooth spy to="nav" href="#nav" aria-label="Till sidans början">
              <i className="fa-solid fa-fire"></i>
            </Link>
          </li>
          <li>
            <Link activeClass="active" smooth spy to="start" href="#start" hashSpy onClick={() => setRefTabParam("")}>Start</Link>
          </li>
          <li>
            <Link activeClass="active" smooth spy to="tjanster" href="#tjanster" hashSpy onClick={() => setRefTabParam("")}>Tjänster</Link>
          </li>
          <li className="dropdown">
            <Link activeClass="active" smooth spy to="referenser" href="#referenser" hashSpy onClick={() => setRefTabParam("")} className="dropdowntrigger">Referenser</Link>
            <ul className="dropdown-menu">
              {referenceCategories.map(category => (
                <li key={category.key}>
                  <Link smooth onClick={() => setRefTabParam(category.key)} to="referenser" href={`/?ref=${category.key}#referenser`}>{category.title}</Link>
                </li>
              ))}
            </ul>
          </li>
          <li>
            <Link activeClass="active" smooth spy to="offert" href="#offert" hashSpy onClick={() => setRefTabParam("")}>Offert</Link>
          </li>
          <li>
            <Link activeClass="active" smooth spy to="foretaget" href="#foretaget" hashSpy onClick={() => setRefTabParam("")}>Om oss</Link>

          </li>
        </ul>
      </nav>
    </section>
    
    <header className="intro" id="nav">

      <img src="/images/logo_i.png" alt="Haglunds kakelugnar och skorstenar" className="logo" />

      <div className="scrollToMain">
        <a href="#main" aria-label="Till sidans innehåll" className="fas fa-chevron-circle-down" onClick={(event) => {
          event.preventDefault();
          document.getElementById("main")?.scrollIntoView({ behavior: 'smooth' });
        }}></a>
      </div>

      <BackgroundVideo />

    </header>

    <main id="main">
      <Outlet />
    </main>
    <footer className="site-footer">
      <div>
        <strong>Mureri &amp; Eldstäder i Söderhamn AB</strong>
        <p><a href="tel:+46702148448">070-214 84 48</a><br /><a href="mailto:daniel@mureriocheldstader.se">daniel@mureriocheldstader.se</a></p>
        {(siteDetails.facebook || siteDetails.instagram) && <nav className="social-links" aria-label="Sociala medier">
          {siteDetails.facebook && <a href={siteDetails.facebook} target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-facebook" aria-hidden="true" /> Facebook</a>}
          {siteDetails.instagram && <a href={siteDetails.instagram} target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-instagram" aria-hidden="true" /> Instagram</a>}
        </nav>}
      </div>
    </footer>
  </>);
}

const NoMatch = () => {
  return (
    <div>
      <h2>Nothing to see here!</h2>
      <p>
        <Link to="/">Go to the home page</Link>
      </p>
    </div>
  );
}